"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungFormatter = void 0;
const VerpackungFormValidator_1 = require("./VerpackungFormValidator");
class VerpackungFormatter {
    static breite(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.breite(options);
    }
    static laenge(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.laenge(options);
    }
    static kerndurchmesser(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.kerndurchmesser(options);
    }
    static flanschdurchmesser(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.flanschdurchmesser(options);
    }
    static flanschstaerke(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.flanschstaerke(options);
    }
    static trommelbelastungMax(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.trommelbelastungMax(options);
    }
    static verpackungPrice(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.verpackungPrice(options);
    }
    static konfektionierungPrice(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.konfektionierungPrice(options);
    }
    static count(options) {
        return VerpackungFormValidator_1.VerpackungFormValidator.count(options);
    }
}
exports.VerpackungFormatter = VerpackungFormatter;
//# sourceMappingURL=VerpackungFormatter.js.map